import type { StatusPillTone } from '../../../shared/surface-cards/StatusPill';
import type { SupportTicketRow } from '../services/supportTicketsRepo';

export const SUPPORT_CREATE_A11Y_LABEL = 'Escribir a soporte';

export const supportTypeLabel = (t: SupportTicketRow['ticket_type']) =>
  t === 'support' ? 'Soporte' : 'Mejora';

export const supportStatusLabel = (s: SupportTicketRow['status']) => {
  if (s === 'submitted') return 'Enviado';
  if (s === 'triaged') return 'En curso';
  return 'Cerrado';
};

export const supportStatusTone = (s: SupportTicketRow['status']): StatusPillTone => {
  if (s === 'submitted') return 'neutral';
  if (s === 'triaged') return 'service';
  return 'success';
};
